import { render } from "./ClientList.vue?vue&type=template&id=a48dd1dc"
import script from "./ClientList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ClientList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a48dd1dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a48dd1dc', __exports__)) {
    api.reload('a48dd1dc', __exports__)
  }
  
  module.hot.accept("./ClientList.vue?vue&type=template&id=a48dd1dc", () => {
    api.rerender('a48dd1dc', render)
  })

}


export default __exports__